import { Routes } from '@angular/router';

import { authGuard, publicGuard, adminGuard, adminResellerGuard } from '@core/guards';

import { Login } from '@modules/login/pages';
// import { Signup } from '@modules/signup/pages';
import { Home as HomeLayout } from '@layout/home/home';
import { Dashboard } from '@modules/dashboard/pages';
import { Message } from '@modules/message/pages';
import { Campaign } from '@modules/campaign/pages';
import { ScheduledCampaign } from '@modules/scheduled-campaign/pages';
import { History } from '@modules/history/pages';
import { Reseller } from '@modules/reseller/pages';
import { SubReseller } from '@modules/sub-reseller/pages';
import { Package } from '@modules/package/pages';
import { Settings } from '@modules/settings/pages';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: Login,
    canActivate: [publicGuard],
    pathMatch: 'full'
  },
  // {
  //   path: 'signup',
  //   component: Signup,
  //   canActivate: [publicGuard],
  //   pathMatch: 'full'
  // },
  {
    path: '',
    component: HomeLayout,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        pathMatch: 'full'
      },
      {
        path: 'message',
        component: Message,
        pathMatch: 'full'
      },
      {
        path: 'campaign',
        component: Campaign,
        pathMatch: 'full'
      },
      {
        path: 'scheduled-campaigns',
        component: ScheduledCampaign,
        pathMatch: 'full'
      },
      {
        path: 'history',
        component: History,
        pathMatch: 'full'
      },
      {
        path: 'reseller',
        component: Reseller,
        pathMatch: 'full',
        canActivate: [adminGuard]
      },
      {
        path: 'sub-reseller',
        component: SubReseller,
        pathMatch: 'full',
        canActivate: [adminResellerGuard]
      },
      {
        path: 'package',
        component: Package,
        pathMatch: 'full',
        canActivate: [adminResellerGuard]
      },
      {
        path: 'settings',
        component: Settings,
        pathMatch: 'full'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
